module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai63-d9e6157760de9a8802af1832dd216575.jpg";